import styled from 'styled-components';
import { breakpoints } from 'config/config';
import { BUTTON_STATES } from 'styles/buttonStates';

export const StyledFarmLocationCard = styled.aside`
  flex: none;
  width: 358px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.whiteSmoke};
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontText};
  color: ${({ theme }) => theme.black};

  .farm-location-map {
    width: 100%;
    aspect-ratio: 856 / 722;
  }

  .farm-location-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
  }

  .farm-location-distance {
    margin: 0;
    font-size: 16px;
    line-height: 1.4;
    color: ${({ theme }) => theme.black2};
  }

  .farm-location-hint {
    margin: 0;
    font-size: 14px;
    line-height: 1.4;
    color: ${({ theme }) => theme.black2};
  }

  .farm-location-enable.ant-btn {
    height: auto;
    padding: 0;
    border: none;
    font: inherit;
    font-weight: 600;
    text-decoration: underline;

    .text {
      font-size: inherit;
    }

    &,
    &${BUTTON_STATES} {
      background: none;
      color: inherit;
    }

    &:disabled {
      background: none;
      color: inherit;
      cursor: default;
      opacity: 0.6;
    }
  }

  .farm-location-actions {
    display: flex;
    align-items: center;
    gap: 8px;

    a {
      padding: 8px 16px;
      border-radius: 40px;
      background-color: ${({ theme }) => theme.navDark};
      color: ${({ theme }) => theme.white};
      font-size: 14px;
      line-height: 1.4;

      &:hover {
        color: ${({ theme }) => theme.white};
        opacity: 0.9;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    width: 300px;

    .farm-location-hint,
    .farm-location-actions a {
      font-size: 0.875rem;
    }

    .farm-location-distance {
      font-size: 1rem;
    }
  }

  @media only screen and (max-width: ${breakpoints.md}px) {
    width: 100%;
  }
`;
